<template>
    <div v-show="activeFiltersCount > 0" class="active-filters">
        <div class="text">
            <img src="/media/images/filter_icon.svg" style="position: relative; width: 24px; top: 3px;">
            <span>{{ $trans('web_search.filters.filter') }}</span>
        </div>
        <template v-for="(filter, index) in SelectedFiltersStore.getActiveFilters()" :key="index">
            <template v-if="filter.length">
                <template v-for="(option, subIndex) in filters[index]" :key="subIndex">
                    <Tag v-if="filter.includes(option.id)" :text="option.value" :hover="true" :close="true" @close="SelectedFiltersStore.setState(index, option.id, false)" />
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import Tag from './Utils/Tag';

import { mapStores, mapState } from 'pinia'
import { useSelectedFiltersStore } from '@/stores/SelectedFiltersStore'

export default {
    components: {
        Tag,
    },
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStores(useSelectedFiltersStore), // useSelectedFiltersStore => this.SelectedFiltersStore
        ...mapState(useSelectedFiltersStore, {
            storeSelectedFilters: 'selectedFilters',
            
        }),
        activeFiltersCount() {
            return this.SelectedFiltersStore.getActiveFiltersCount();
        },
    },
}
</script>

<style scoped>
.active-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
    border-top: 1px solid;
    padding-top: 10px;
}

.active-filters > .text {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 24px;
    font-weight: 500;
    color: #3C3C3C;
}
</style>
